import { useEffect } from 'react';
import { getMUICache, appendStyleSheet, getImageUrl, getImageSize, convertEpochTime, getImageId, fetchAnchorValue } from '../../../common/utils';
import { CacheProvider } from '@emotion/react';
import "./WebStoriesListThree.css";
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
  const { showDate, item, cardTextColor, cardBGColor, anchorLinksValue } = props;
  const { hl, imageid, pubInfo, upd, wu } = item;
  const cache = getMUICache();
  let styles = require("./WebStoriesListThree.css");
  appendStyleSheet("WebStoriesListThree", styles);

  // let imageSize = getImageSize(imageid);


  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();
    useEffect(()=>{
        EagerLoadImages()
    },[]);
  return (
    <CacheProvider value={cache}>

      <a className='ThemeThreeWebStoriesListMainWrap' role="link" aria-label="Next Page" href={(wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu))} target={fetchAnchorValue(anchorLinksValue, (wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu)))} >
        <div className="ThemeThreeHomeWebStroiesListCardWrap">
          <div className="ThemeThreeHomeWebStroiesardListImgWrap">
            {
              getImageSize(imageid) && <picture>
                {/* Add multiple source elements for different image sources */}
                <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 475, 376, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />

                <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 265, 354, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />

                <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
              </picture>
            }
          </div>
          <div className='ThemeThreeHomeWebStroiesMainListContentWrap'>
            <div className="ThemeThreeHomeWebStroiesListContentWrap" style={{ backgroundColor: cardBGColor }}>
              <p className="ThemeThreeHomeWebStroiesListDiscription" style={{ color: cardTextColor }}>{hl}</p>
            </div>
            <div className='themeThreedateAgencyWrap'>
              <p className="ThemeThreeCommonAuthorWrapper">{showDate ? convertEpochTime(upd, 'updated', "DD MMM YYYY") : ""}</p>
            </div>
          </div>
        </div>
      </a>

    </CacheProvider>
  )
}
export default Card;